import React, { useState } from "react";
import { BookOpenCheck, FileVideo } from "lucide-react";
import ProcedureRecordingsList from "../components/ProcedureRecordingsList";
import ProcedureVideoUploadDialog from "../components/ProcedureVideoUploadDialog";

export default function ProcedureLibrary() {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="min-h-full overflow-y-auto bg-gray-50 p-4 sm:p-6 lg:p-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-7 rounded-2xl bg-gradient-to-r from-violet-700 to-indigo-700 px-5 py-6 text-white shadow-sm sm:px-7">
          <div className="flex items-start gap-4">
            <div className="rounded-xl bg-white/15 p-3"><BookOpenCheck className="w-7 h-7" /></div>
            <div>
              <h1 className="text-2xl font-bold">Procedimentos gravados</h1>
              <p className="mt-1 text-sm text-violet-100">Encontre e reutilize vídeos autorizados pela equipe em novos atendimentos.</p>
            </div>
          </div>
        </div>
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <FileVideo className="w-5 h-5 text-violet-600" />
            <h2 className="font-semibold text-gray-800">Biblioteca de procedimentos</h2>
          </div>
          <ProcedureVideoUploadDialog onUploaded={() => setRefreshKey((value) => value + 1)} />
        </div>
        <ProcedureRecordingsList refreshKey={refreshKey} />
      </div>
    </div>
  );
}
